// extracted by mini-css-extract-plugin
module.exports = {"slide":"Note_slide_1NkXu","slide-reverse":"Note_slide-reverse_2yYIi"};